export default "__VITE_ASSET__sANFkyKx__"